import React from 'react';

import { ButtonTertiary } from '@spotify-internal/encore-creator-web';

import { DeleteConfirmation } from './DeleteConfirmation';
import { useConfirmationDialog } from './useConfirmationDialog';
import { useDelete } from './useDelete';

interface ConfirmationProps {
  onConfirm: () => void;
  onCancel: () => void;
  onFailure: () => void;
  onSuccess: () => void;
}

export function ArtistFundraisingPickDelete(props: ConfirmationProps) {
  const {
    close: closeConfirmationDialog,
    isOpen: confirmationDialogIsOpen,
    open: openConfirmationDialog,
  } = useConfirmationDialog();

  const [shouldShowLoadingOverlay, setLoading] = React.useState(false);

  const sendDeleteRequest = useDelete(props.onSuccess, props.onFailure);

  async function onConfirm() {
    setLoading(true);
    await sendDeleteRequest();
    setLoading(false);
    // Don't close confirmation dialog until after loading is complete since the
    // loading indicator lives in the DeleteConfirmation component subtree
    closeConfirmationDialog();
    props.onConfirm();
  }

  function onCancel() {
    closeConfirmationDialog();
    props.onCancel();
  }

  return (
    <>
      <ButtonTertiary
        buttonSize={ButtonTertiary.sm}
        onClick={() => {
          openConfirmationDialog();
        }}
        theme={ButtonTertiary.darkTheme}
        condensed
      >
        Remove
      </ButtonTertiary>

      {confirmationDialogIsOpen ? (
        <DeleteConfirmation
          loading={shouldShowLoadingOverlay}
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      ) : null}
    </>
  );
}
